import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

import { StyledLoading } from './Loading.styles';

export const Loading = ({
  fill,
  height,
  size = 50,
  ...props
}: {
  fill?: string;
  size?: number;
  className?: string;
  height?: number | string;
}) => (
  <StyledLoading {...props} height={height} data-suridata-tag='loading'>
    <LoadingSpinner size={size} fill={fill} />
  </StyledLoading>
);
